import get from './get';
import update from './update';
import add from './add';

export {
  get,
  update,
  add
};


// WEBPACK FOOTER //
// ./src/services/api/admin/tagGroups/index.ts